export const GET_ITEM_STATUS_LIST = "GET_ITEM_STATUS_LIST";
export const GET_ITEM_KEYWORD_LIST = "GET_ITEM_KEYWORD_LIST";

export const ITEM_LIST_ACTION = "ITEM_LIST_ACTION";
